export type { LocaleContextProps, LocaleProviderProps } from "./Locale";
export { default, LocaleConsumer, LocaleProvider } from "./Locale";
